import React from 'react';
import { Helmet } from 'react-helmet';

const SEOHead = ({ 
  title, 
  description, 
  canonical, 
  keywords = "dépannage informatique, réparation PC, Nantes, Loire-Atlantique, à domicile",
  ogImage = "https://mon-depannage-informatique.fr/static/media/mon-depannage-informatique-logo.webp"
}) => {
  // S'assurer que l'URL canonique n'utilise jamais www
  const cleanCanonical = canonical ? canonical.replace('www.', '') : '';
  const baseUrl = 'https://mon-depannage-informatique.fr';
  
  return (
    <Helmet>
      {/* Balises de base */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* URL canonique (sans www) */}
      <link rel="canonical" href={cleanCanonical || baseUrl} />
      
      {/* Balises Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={cleanCanonical || baseUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Mon Dépannage Informatique" />
      
      {/* Balises Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Balises techniques SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="language" content="fr" />
      <meta name="geo.region" content="FR-44" />
      <meta name="geo.placename" content="Nantes" />
      <meta name="geo.position" content="47.2184;-1.5536" />
      <meta name="ICBM" content="47.2184, -1.5536" />
      
      {/* Schema.org pour local business */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Mon Dépannage Informatique",
          "description": "Dépannage informatique à domicile à Nantes et en Loire-Atlantique",
          "url": "https://mon-depannage-informatique.fr",
          "telephone": "+33-2-40-XX-XX-XX",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Nantes",
            "addressRegion": "Loire-Atlantique",
            "addressCountry": "FR"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 47.2184,
            "longitude": -1.5536
          },
          "openingHours": "Mo-Fr 08:00-18:00",
          "serviceArea": {
            "@type": "GeoCircle",
            "geoMidpoint": {
              "@type": "GeoCoordinates",
              "latitude": 47.2184,
              "longitude": -1.5536
            },
            "geoRadius": "50000"
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEOHead;
